export const COLLAPSE_MENU = '@able/COLLAPSE_MENU';
export const COLLAPSE_TOGGLE = '@able/COLLAPSE_TOGGLE';
export const CHANGE_LAYOUT = '@able/CHANGE_LAYOUT';
export const CHANGE_SUB_LAYOUT = '@able/CHANGE_SUB_LAYOUT';
export const LAYOUT_TYPE = '@able/LAYOUT_TYPE';
export const RESET = '@able/RESET';
export const NAV_BRAND_COLOR = '@able/NAV_BRAND_COLOR';
export const HEADER_BACK_COLOR = '@able/HEADER_BACK_COLOR';
export const RTL_LAYOUT = '@able/RTL_LAYOUT';
export const NAV_FIXED_LAYOUT = '@able/NAV_FIXED_LAYOUT';
export const HEADER_FIXED_LAYOUT = '@able/HEADER_FIXED_LAYOUT';
export const BOX_LAYOUT = '@able/BOX_LAYOUT';
export const NAV_CONTENT_LEAVE = '@able/NAV_CONTENT_LEAVE';
export const NAV_COLLAPSE_LEAVE = '@able/NAV_COLLAPSE_LEAVE';
//MODAL OPEN
export const MODAL_OPEN = 'MODAL_OPEN';

//MODAL CLOSE
export const MODAL_CLOSE = 'MODAL_CLOSE';

//PROPERTY MODAL OPEN
export const PROPERTY_MODAL_OPEN = 'PROPERTY_MODAL_OPEN';

//PROPERTY MODAL CLOSE
export const PROPERTY_MODAL_CLOSE = 'PROPERTY_MODAL_CLOSE';

//STYLE MODAL OPEN
export const STYLE_MODAL_OPEN = 'STYLE_MODAL_OPEN';

//STYLE MODAL CLOSE
export const STYLE_MODAL_CLOSE = 'STYLE_MODAL_CLOSE';

//FORMAT MODAL OPEN
export const FORMAT_MODAL_OPEN = 'FORMAT_MODAL_OPEN';

//FORMAT MODAL CLOSE
export const FORMAT_MODAL_CLOSE = 'FORMAT_MODAL_CLOSE';

//SINGLE ROW MODAL OPEN
export const SINGLE_ROW_MODAL_OPEN = 'SINGLE_ROW_MODAL_OPEN';

//PROPERTY MODAL CLOSE
export const SINGLE_ROW_MODAL_CLOSE = 'SINGLE_ROW_MODAL_CLOSE';

// FEEDBACK MODAL OPEN
export const FEEDBACK_MODAL_OPEN = 'FEEDBACK_MODAL_OPEN';

// FEEDBACK MODAL CLOSE
export const FEEDBACK_MODAL_CLOSE = 'FEEDBACK_MODAL_CLOSE';

//CREATE AND CLOSE BUTTON
export const CREATE_AND_CLOSE_BUTTON = 'CREATE_AND_CLOSE_BUTTON';
//CREATE NEW BUTTON
export const CREATE_AND_ADD_NEW_BUTTON = 'CREATE_AND_ADD_NEW_BUTTON';
//UPDATE BUTTON
export const UPDATE_BUTTON = 'UPDATE_BUTTON';
//DELETE BUTTON
export const DELETE_BUTTON = 'DELETE_BUTTON';
export const REGENERATE_MODAL_CLOSE = 'REGENERATE_MODAL_CLOSE';

export const LOADING_MODAL_OPEN = 'LOADING_MODAL_OPEN';
export const LOADING_MODAL_CLOSE = 'LOADING_MODAL_CLOSE';

export const EXPANDABLE_MENU = 'EXPANDABLE_MENU';


